import { AlertNotReleased } from "@/shared/components/alerts/alert-not-released";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { Outlet } from "react-router";

export default function OffersRoute() {
  const isReleased = useBooleanFlagValue("gsm.htz.offers", true);
  if (!isReleased) {
    return <AlertNotReleased />;
  }

  return <Outlet />;
}
